import axios from "axios";
import { Template, TemplateShcema, UpsetTemplateDTO } from "../types/templates";
import { toCamelCase, toSnakeCase } from "../utils/objectHelper";
import { LangType } from "../types/LangType";

export const TemplatesTransport = {
    save: async (object: UpsetTemplateDTO, id: number | undefined | null): Promise<Template> => {
        const { data } = await axios.request<Template>({
            method: id ? "put" : "post",
            url: id ? `/template/${id}` : "/template",
            data: toSnakeCase(object),
        });

        return TemplateShcema.cast(toCamelCase(data));
    },

    findAll: async (lang?: LangType): Promise<Array<Template>> => {
        const { data } = await axios.request<Array<Template>>({
            method: "get",
            url: `/template/listAll${lang ? `?lang=${lang}` : ""}`,
        });

        return data.map((current) => TemplateShcema.cast(toCamelCase(current)));
    },

    findAvailableTags: async (lang: LangType): Promise<Array<string>> => {
        const { data } = await axios.request<Array<string>>({
            method: "get",
            url: `/template/findAvailableTags?lang=${lang}`,
        });

        return data;
    },

    toggleActive: async (object: Template): Promise<void> => {
        const action = "toggleActive";
        await axios.patch(`/templates/${object.id}/actions/${action}`);
    },

    formTransformer: (object?: Template): UpsetTemplateDTO | null => {
        if (!object) {
            return null;
        }

        return {
            lang: object.lang,
            title: object.title,
            text: object.text,
            tag: object.tag,
        };
    },
};
